import MatchedMap from 'utilities/src/matchedMap';

import { InputVariantsEnum } from '../../../utils/variants';
import { InputTypeEnum } from '../../../utils/types';
import { type InputThemeProps } from '../../../utils/themes';

/**
 * LabelIn Common Classes
 */

const labelInClasses = 'label paragraph-s text-neutrals-500 leading-5';

const labelInOptionalClasses = 'paragraph-xs italic';

/**
 * LabelIn Focus Classes
 */

const labelInFocusTypeClasses = new MatchedMap([
  [
    InputTypeEnum.Input,
    'group-focus-within:font-medium group-focus-within:paragraph-xs group-focus-within:leading-5',
  ],
  [
    InputTypeEnum.Textarea,
    'group-focus-within:font-medium group-focus-within:paragraph-xs group-focus-within:pb-[2px]',
  ],
]);

const labelInFocusVariantClasses = new MatchedMap([
  [InputVariantsEnum.Primary, 'group-focus-within:text-primary-600'],
  [InputVariantsEnum.Secondary, 'group-focus-within:text-secondaryPurple-600'],
]);

/**
 * Blog Theme
 */

const inputLabelInBlogTheme = ({
  inputType,
  inputVariant,
}: Pick<InputThemeProps, 'inputType' | 'inputVariant'>) => ({
  labelInThemeClasses: labelInClasses,
  labelInOptionalThemeClasses: labelInOptionalClasses,
  labelInFocusThemeClasses: labelInFocusTypeClasses
    .get(InputTypeEnum[inputType])
    .concat(' ', labelInFocusVariantClasses.get(InputVariantsEnum[inputVariant])),
});

export default inputLabelInBlogTheme;
